import { isKharonV2Allowed } from '@retracedgmbh/modules';
import { useSessionStore } from '@/store/sessionStore';

/**
 * Mirrors the old frontend's `useCanAccessKharonV2`: entity screening is
 * unrestricted for every company except Columbia, which is limited to an
 * allow-list of user IDs. In frontend-v2 the session user is already the
 * impersonated user, so `companyId` / `id` are the effective values.
 */
export function useCanAccessEntityScreening(): boolean {
  const user = useSessionStore(s => s.user);
  return isKharonV2Allowed(user?.companyId, user?.id);
}
